import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class OverdraftAccountService {
    private baseApiUrl: string;

    constructor (configurationService: ConfigurationService, private httpClient: HttpClient) {
        this.baseApiUrl = configurationService.BaseApiUrl;
    }

    getFiltered(filter: string, pageIndex: number, pageSize: number,
      sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

      const params = {
        filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
      };

      return this.httpClient.post(this.baseApiUrl + 'overdraftaccount/filter', params).pipe(
        map((res: any) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    getAll(forMaintenance: boolean = false): Observable<any> {
      return this.httpClient.get(this.baseApiUrl + `overdraftaccount?isMaintenance=${forMaintenance}`).pipe(
       map((res: any) =>  res),
       catchError((err: any) => observableThrowError(err.message || 'Server error')));
   }

    getById(id: number, forMaintenance: boolean = false): Observable<any> {
      return this.httpClient.get(this.baseApiUrl + `overdraftaccount/${id}?isMaintenance=${forMaintenance}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    create(overdraftAccount: any): Observable<any> {
      return this.httpClient.post(this.baseApiUrl + 'overdraftaccount', overdraftAccount).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    update(overdraftAccount: any): Observable<any> {
      return this.httpClient.put(this.baseApiUrl + 'overdraftaccount', overdraftAccount).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    authorise(id: number): Observable<any> {
      return this.httpClient.post(this.baseApiUrl + 'overdraftaccount/authorise', id).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    delete(id: number): Observable<any> {
      return this.httpClient.delete(this.baseApiUrl + `overdraftaccount/${id}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }

    computeInstallmentAndFees(computeData: any): Observable<any> {
      return this.httpClient.post(this.baseApiUrl + `overdraftaccount/compute`, computeData).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
    getByCustomerId(customerId: number , applicationModuleId : number): Observable<any> {
      return this.httpClient.get(this.baseApiUrl + `overdraftaccount/odcustomer/${customerId}?applicationModuleId=${applicationModuleId}`).pipe(
        map((res: Response) => res),
        catchError((err: any) => observableThrowError(err.message || 'Server error')));
    }
  }
